import React from "react";
// React Router Dom
import { Routes, Route, useLocation } from "react-router-dom";

// Se cargan las vistas que posteriormente se cargaran a las rutas
import App from "../App";
import Layout from "../pages/Layout";
import NoPage from "../pages/NoPage";
import Configuration from "../pages/Configuration";
import VotingRoom from "../pages/VotingRoom";
import StatsOfMatch from "../pages/StatsOfMatch";

import { AnimatePresence } from "framer-motion";

export default function AnimatedRoutes() {
  // PARA FRAMER MOTION
  const location = useLocation();
  return (
    <AnimatePresence>
      {/* Para que funcione FRAMER MOTION es necesario pasarle la location y la key */}
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Layout />} />
        <Route index element={<App />} />
        <Route path="Configuration" element={<Configuration />} />
        <Route path="StatsOfMatch" element={<StatsOfMatch />} />
        <Route path="VotingRoom" element={<VotingRoom />} />
        <Route path="*" element={<NoPage />} />
      </Routes>
    </AnimatePresence>
  );
}
